export function getRegistrationStatus(phases) {
  const registrationPhase = phases.find(
    phase => phase.type === 'registration'
  );
  if (!registrationPhase) {
    return 'unknown';
  }
  return new Date() > new Date(registrationPhase.end)
    ? 'closed'
    : 'started';
}